import React from 'react';

import { ChevronRightIcon } from 'icons';
import { IconButton, Typography, styled } from 'netline-ui';

import styles, { preferencesListItemClasses } from './PreferencesListItem.styles';

const PreferencesListItemRoot = styled('div', { name: preferencesListItemClasses.$name })(styles);

type PreferencesListItemProps = {
  title: string;
  handleClick?: () => void;
};

const PreferencesListItem = ({ title, handleClick }: PreferencesListItemProps) => {
  return (
    <PreferencesListItemRoot
      className={preferencesListItemClasses.root}
      data-testid="PreferencesListItem-root"
      onClick={handleClick}
    >
      <Typography className={preferencesListItemClasses.title} data-testid="PreferencesListItem-title">
        {title}
      </Typography>
      <IconButton data-testid="PreferencesListItem-icon">
        <ChevronRightIcon />
      </IconButton>
    </PreferencesListItemRoot>
  );
};

export default PreferencesListItem;
